// CÓDIGO 100% COMPLETO
import React, { useState, useRef } from 'react';
import useClickOutside from '../../hooks/useClickOutside';

const CustomSelect = ({ options, value, onChange, placeholder = "Selecione uma opção", label }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    const handleSelect = (optionValue) => {
        onChange({ target: { value: optionValue } }); // Emula o evento 'e' para compatibilidade
        setIsOpen(false);
    };

    useClickOutside(selectRef, () => setIsOpen(false));

    const displayValue = options.find(opt => opt.value === value)?.label || placeholder;

    return (
        <div className="relative w-full text-white" ref={selectRef}>
            {label && <label className="block text-sm font-medium mb-1 text-gray-300">{label}</label>}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between p-3 text-left bg-white/10 rounded-lg border border-white/30 focus:outline-none focus:ring-2 focus:ring-indigo-400/80 transition-all duration-200"
            >
                <span className={value ? 'text-white' : 'text-gray-400'}>{displayValue}</span>
                <svg className={`w-5 h-5 transition-transform duration-300 text-gray-400 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
            </button>
            
            {isOpen && (
                <div className="absolute top-full mt-2 w-full z-50 bg-gray-800/90 border border-white/20 backdrop-filter backdrop-blur-lg rounded-lg shadow-xl overflow-hidden animate-fade-in">
                    <ul className="max-h-60 overflow-y-auto">
                        {options.map((option) => (
                            <li
                                key={option.value}
                                onClick={() => handleSelect(option.value)}
                                className={`p-3 cursor-pointer hover:bg-white/10 transition-colors duration-200 ${option.value === value ? 'bg-indigo-500/50' : ''}`}
                            >
                                {option.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default CustomSelect;